import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TellerGlobalServiceService {


  private selectedTeller$ = new BehaviorSubject<any>('{}')

  constructor() { }

  setSelectedTeller(selectedTeller: any){
    this.selectedTeller$.next(selectedTeller);
  }

  getSelectedTeller$(){
    return this.selectedTeller$.asObservable();
  }
}
